export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "订单状态", prop: "status", slots: "status", width: 120 },
    { label: "openid", prop: "openid", slots: "openid", minWidth: 230 },
    { label: "手机号", prop: "phone", width: 140 },
    { label: "金额", prop: "money", slots: "money", width: 130 },
    { label: "订单描述", prop: "msg", slots: "msg", minWidth: 200 },
    {
      label: "订单创建时间",
      prop: "createdTime",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      slots: "operation",
      width: 160,
    },
  ];
}
